import { Core } from '@strapi/strapi';
import { KoniBotServiceType } from "./services/bot/koni-bot";
import {TelegramBotServiceType} from "./services/content-type/telegram-bot";
import {SynchronizeActionServiceType} from "./services/bot/synchronize-action";

export default ({ strapi }: { strapi: Core.Strapi }) => {
  // Init telegram Bot
  // Bot action should be setup in the register phrase
  strapi.plugin('telegram-bot').service<TelegramBotServiceType>('telegram-bot').autoCreateBot().catch(strapi.log.error);
  strapi.plugin('telegram-bot').service<KoniBotServiceType>('koniBot').launch().catch(strapi.log.error);
  strapi.plugin('telegram-bot').service<SynchronizeActionServiceType>('synchronizeAction').launchCrawlerBot().catch(strapi.log.error);
};
